import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { colors, fonts } from '../tokens'

const useStyles = makeStyles({
  backdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 1400,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'rgba(0,0,0,.48)',
    fontFamily: fonts.ui,
    color: colors.navy,
  },
  dialog: {
    width: '100%',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 24px 48px -8px rgba(0,0,0,.24)',
  },
  head: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
    padding: '20px 24px 12px',
  },
  title: {
    fontSize: '18px',
    fontWeight: 600,
  },
  subtitle: {
    marginTop: 2,
    fontSize: '13px',
    lineHeight: 1.5,
    color: colors.muted,
  },
  close: {
    display: 'flex',
    padding: 4,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    color: colors.muted,
  },
  body: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
    padding: '14px 24px',
    borderTop: `1px solid ${colors.border}`,
  },
})

/** Centered dialog rendered in a portal; closes on backdrop click / Escape. */
const Modal = ({
  open,
  onClose,
  title,
  subtitle,
  footer,
  children,
  maxWidth = 520,
}) => {
  const classes = useStyles()

  useEffect(() => {
    if (!open) return undefined
    const handleKeyDown = event => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [open, onClose])

  if (!open) return null

  return ReactDOM.createPortal(
    <div className={classes.backdrop} onClick={onClose}>
      <div
        className={classes.dialog}
        style={{ maxWidth }}
        role="dialog"
        aria-modal="true"
        onClick={event => event.stopPropagation()}
      >
        <div className={classes.head}>
          <div>
            <div className={classes.title}>{title}</div>
            {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
          </div>
          <button type="button" className={classes.close} onClick={onClose}>
            <Icon icon="tabler:x" width={18} height={18} />
          </button>
        </div>
        <div className={classes.body}>{children}</div>
        {footer && <div className={classes.footer}>{footer}</div>}
      </div>
    </div>,
    document.body,
  )
}

export default Modal
